import Link from 'next/link';
import { useRouter } from 'next/router';

import Text from '@/v2/components/Typography/Text';
import Colors from '@/v2/constants/Colors';
import { usePlausibleContext } from '@/shared/PlausibleAnalytics/PlausibleAnalytics';

import menuItems from '../menuItems';
import MenuButtons from '../MenuButtons/MenuButtons';
import { Container } from './DesktopMenu.styled';

export default function DesktopMenu() {
  const router = useRouter();
  const currentPath = router.asPath;
  const plausibleContext = usePlausibleContext();

  const handlePlausibleEvent = (event, props) => {
    if (event) {
      plausibleContext.actions.sendPlausibleEvent(event, props);
    }
  };

  return (
    <Container>
      {menuItems.map((item) => {
        const isActive = currentPath == item.href;

        return (
          <Link
            href={item.href}
            key={item.href}
            onClick={() =>
              handlePlausibleEvent(item.plausibleEvent, item.plausibleProps)
            }
          >
            <Text
              variant="cardTitle"
              color={isActive ? Colors.ACCENT_VARIANTS[90] : Colors.BLUE}
            >
              {item.label}
            </Text>
          </Link>
        );
      })}
      <MenuButtons />
    </Container>
  );
}
